import Vue from 'vue';
import doclink from '@/DocLink.vue'


export default Vue.component('faq', {
    components: {
        doclink
    },
    props: {
        n: String, // name (that we're looking up the topic for)
        t: String  // target (html anchor) for the topic, if different from the name
    }
});
